import React, { useState } from "react";
import { X } from "lucide-react";
import ViewUpdate from "../ViewUpdate";
import DeviceHistory from "../DeviceHistory";
import { Device } from "@schemas";

const CATEGORIES = {
  view_update: "View/Update",
  device_history: "Device History",
};

interface ExistingDeviceProps {
  onClose: () => void;
  data?: Device;
}
const ExistingDevice: React.FC<ExistingDeviceProps> = ({ onClose, data }) => {
  const [activeButton, setActiveButton] = useState(CATEGORIES.view_update);
  const handleClick = (buttonName: string) => {
    setActiveButton(buttonName);
  };
  return (
    <div className="h-full">
      <div
        className={
          "p-10 fixed inset-0 z-20 bg-gray-600 bg-opacity-50 overflow-hidden w-screen h-screen flex items-center justify-center"
        }
      >
        {/* <div className="p-10 fixed inset-0 z-20 bg-gray-600 bg-opacity-50 overflow-y-auto h-screen w-screen flex items-center justify-center"> */}
        <div className="w-full p-2 bg-white rounded-lg flex flex-col h-full">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-xl font-bold text-custom-blue7 pl-2">
              {`${data?.device_name} (${data?.device_id})`}
            </h1>

            <button
              className="p-2 bg-custom-blue7 rounded-full"
              onClick={onClose}
            >
              <X size={20} className="text-gray-50" />
            </button>
          </div>
          <div className="flex flex-row justify-start w-full pl-2">
            <div className="space-x-2">
              <button
                className={`px-6 py-2 rounded-t-md w-[150px] 
                      ${
                        activeButton === CATEGORIES.view_update
                          ? "bg-custom-blue8 text-custom-blue6 "
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
                onClick={() => handleClick(CATEGORIES.view_update)}
              >
                View/Update
              </button>
              <button
                className={`px-3 py-2 rounded-t-md w-[150px] 
                      ${
                        activeButton === CATEGORIES.device_history
                          ? "bg-custom-blue8 text-custom-blue6 "
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
                onClick={() => handleClick(CATEGORIES.device_history)}
              >
                Device History
              </button>
            </div>
          </div>
          <div className="flex h-auto overflow-auto">
            {activeButton === CATEGORIES.view_update && (
              <ViewUpdate data={data} />
            )}
            {activeButton === CATEGORIES.device_history && (
              <DeviceHistory deviceId={data?.device_id} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExistingDevice;
